import React, { useEffect, useState } from 'react';
import PopModal from '../../Constant/Custom/Models/PopModal';
import Loader from '../../Constant/Custom/Loader';
import axios from 'axios';
import { serverUrl } from '../../Constant/Static/config';

function Special({ studentData, handlePrev, handleNext }) {

  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState({ title: '', text: '', icon: '' });
  const [onConfirm, setOnConfirm] = useState(() => () => { });
  const [showCancelButton, setShowCancelButton] = useState(false);
  const [onCancel, setOnCancel] = useState(() => () => { });

  const [changes, setChanges] = useState(new Set());
  const [changedFields, setChangedFields] = useState({
    disability: false,
    sports: false,
    sportsLvl: false,
    freedomFighter: false,
    exService: false,
    srilankanRefugee: false,
    firstGraduate: false
  })

  const [csrfToken, setCsrfToken] = useState('');
  // const [errors, setErrors] = useState({});

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => {
    setIsModalOpen(false);
  }

  const [specialForm, setSpecialForm] = useState({
    disability: '',
    sports: '',
    sportsLvl: 0,
    freedomFighter: '',
    exService: '',
    srilankanRefugee: '',
    firstGraduate: ''
  });

  const [orgData, setOrgData] = useState({
    disability: '',
    sports: '',
    sportsLvl: 0,
    freedomFighter: '',
    exService: '',
    srilankanRefugee: '',
    firstGraduate: ''
  });

  const changedFieldsMap = {
    disability: 'Disablity',
    sports: 'Sports',
    sportsLvl: 'Sports Level',
    freedomFighter: 'Freedom fighter',
    exService: 'Ex-serviceman',
    srilankanRefugee: 'Srilankan refugee',
    firstGraduate: 'First graduate'
  }

  const setDefaultForm = () => {
    setSpecialForm({
      disability: '',
      sports: '',
      sportsLvl: 0,
      freedomFighter: '',
      exService: '',
      srilankanRefugee: '',
      firstGraduate: ''
    })
    setOrgData({
      disability: '',
      sports: '',
      sportsLvl: 0,
      freedomFighter: '',
      exService: '',
      srilankanRefugee: '',
      firstGraduate: ''
    })
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    let isChanged = value !== orgData[name];


    setSpecialForm((prevState) => ({
      ...prevState,
      [name]: value,
      ...(name === "sports" && value === "N" && { sportsLvl: 0 }),
    }));

    setChangedFields((prev) => {
      const updatedChangedFields = { ...prev };
      updatedChangedFields[name] = isChanged;
      if (name === "sports") {
        updatedChangedFields['sportsLvl'] = !updatedChangedFields['sportsLvl']
      }
      return updatedChangedFields;
    })
  };

  const validateForm = () => {
    const requiredFields = Object.keys(specialForm);
    const errors = [];

    requiredFields.forEach((field) => {
      if (field !== 'appNo' && field !== 'appName' && field !== 'email' && field !== 'phone' && field !== 'sportsLvl')
        if (specialForm[field] !== 'Y' && specialForm[field] !== 'N') {
          errors.push(`${field.charAt(0).toUpperCase() + field.slice(1)} must be 'Y' or 'N'.`);
        }
    });
    if (specialForm.sports === "Y" && specialForm.sportsLvl === 0) {
      errors.push("Please select the participation level")
    }
    if (errors.length > 0) {
      // console.log(errors);
      return false;
    }

    // console.log(errors);


    return true;
  };

  const submitDetails = async () => {
    const userData = studentData;
    let changesToSend = [...changes]
    try {
      const response = await axios.post(`${serverUrl}/api/cv/student/special-update`, {
        appno: userData.APPLN_NO,
        email: userData.EMAIL,
        mobile: userData.MOBILE,
        specialForm,
        changesToSend
      }, {
        headers: {
          'CSRF-Token': csrfToken
        },
        withCredentials: true
      });
      if (response.status === 200) {
        setShowCancelButton(false)
        setModalType({
          icon: 'success',
          title: 'Success',
          text: 'Special Reservation Details are saved.',
        });
        openModal();
        setOnConfirm(() => handleNext);
      } else {
        // console.log(response);
      }
    } catch (err) {
      console.error('Failed to store data', err);
    }
  }

  const handleSpecialDetailSubmit = async () => {
    setShowCancelButton(false);

    const userData = studentData;

    // console.log(changedFields);


    if (!validateForm()) {
      setModalType({
        icon: 'warning',
        title: 'Warning',
        text: 'Please Fill All the Required Details',
      });
      openModal();
      setOnConfirm(() => closeModal);
      // console.log('Form is not valid');
      return;
    } else if (userData) {
      let confirmationText = changes.size > 0 ? `Changed Fields :  ${[...changes].join(' | ')}` : 'No fields are changed';
      setModalType({
        title: 'Confirmation',
        icon: 'info',
        text: confirmationText
      })
      setShowCancelButton(true);
      setOnCancel(() => closeModal);
      setOnConfirm(() => submitDetails);
      openModal();
    }
  };

  useEffect(() => {
    for (let val in changedFields) {
      if (changedFields[val]) {
        setChanges((prev) => new Set([...prev, changedFieldsMap[val]]))
      } else {
        setChanges((prev) => new Set([...prev].filter(item => item !== changedFieldsMap[val])));
      }
    }
  }, [changedFields])

  useEffect(() => {
    const fetchCsrfToken = async () => {
      try {
        const response = await axios.get(`${serverUrl}/api/csrf-token`, {
          withCredentials: true  // Ensure cookies are sent
        });
        setCsrfToken(response.data.csrfToken);  // Set CSRF token
      } catch (error) {
        console.error('Error fetching CSRF token:', error);
      }
    };

    fetchCsrfToken();
  }, []);

  useEffect(() => {
    const fetchUserData = async () => {
      if (csrfToken) {
        try {
          const userData = studentData;
          if (userData) {
            const response = await axios.post(
              `${serverUrl}/api/cv/student/special-load`,
              {
                appno: userData.APPLN_NO,
                email: userData.EMAIL,
                mobile: userData.MOBILE,
                userName: userData.APPLICANT_NAME
              },
              {
                headers: {
                  'CSRF-Token': csrfToken
                },
                withCredentials: true
              }
            );
            if (response.data.disability === "") {
              setDefaultForm();
            } else {
              setSpecialForm(response.data);
              setOrgData(response.data);
            }
          }
        } catch (error) {
          console.error('Error fetching user data:', error);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchUserData();
  }, [csrfToken]);

  if (loading) {
    return <Loader />;
  }

  return (
    <section>
      <div className='section-head-container'>
        <h2 className='section-title'>Special Reservation Details </h2>
      </div>
      <div>
        <div className='special-container'>
          <div className='special-item'>
            <h5>Differently Abled Person:<br />
              <span>&ensp;மாற்றுத்திறனாளி</span>
            </h5>
          </div>
          <div className='special-item'>
            <label className="radio-container">
              <input
                type="radio"
                name="disability"
                value="Y"
                checked={specialForm.disability === 'Y'}
                onChange={handleChange} />
              <span>Yes</span>
            </label>
            <label className="radio-container">
              <input
                type="radio"
                name="disability"
                value="N"
                checked={specialForm.disability === 'N'}
                onChange={handleChange} />
              <span>No</span>
            </label>
          </div>
        </div>
        <div className='special-container'>
          <div className='special-item'>
            <h5>Eminent Sports Person:<br />
              <span>&ensp;சிறந்த விளையாட்டு நபர்</span>
            </h5>
          </div>
          <div className='special-item'>
            <label className="radio-container">
              <input type="radio" name="sports" value="Y"
                checked={specialForm.sports === 'Y'}
                onChange={handleChange} /><span>Yes</span>
            </label>
            <label className="radio-container">
              <input type="radio" name="sports" value="N"
                checked={specialForm.sports === 'N'}
                onChange={handleChange} /><span>No</span>
            </label>
          </div>
        </div>
        {specialForm.sports === 'Y' ? (
          <div className='special-container'>
            <div className='special-item'>
              <h5>Level of Participation :<br />
                <span>&ensp;பங்கேற்பின் அளவு</span>
              </h5>
            </div>
            <div className='special-item'>
              <select
                name='sportsLvl'
                value={specialForm.sports === 'Y' ? specialForm.sportsLvl : 0}
                onChange={handleChange}
              >
                <option value="0" selected="selected">--Select--</option>
                <option value="1" >International Level</option>
                <option value="2">National Level</option>
                <option value="3">State Level</option>
                <option value="4">Divisional Level</option>
              </select>
            </div>
          </div>
        ) : null}
        <div className='special-container'>
          <div className='special-item'>
            <h5>Children of Freedom Fighter:<br />
              <span>&ensp;விடுதலைப் போராட்ட வீரரின் வாரிசு</span>
            </h5>
          </div>
          <div className='special-item'>
            <label className="radio-container">
              <input type="radio" name="freedomFighter" value="Y"
                checked={specialForm.freedomFighter === 'Y'}
                onChange={handleChange} /><span>Yes</span>
            </label>
            <label className="radio-container">
              <input type="radio" name="freedomFighter" value="N"
                checked={specialForm.freedomFighter === 'N'}
                onChange={handleChange} /><span>No</span>
            </label>
          </div>
        </div>
        <div className='special-container'>
          <div className='special-item'>
            <h5>Children of Ex-service man:<br />
              <span>&ensp;முன்னாள் இராணுவ வீரரின்  வாரிசு</span>
            </h5>
          </div>
          <div className='special-item'>
            <label className="radio-container">
              <input type="radio" name="exService" value="Y"
                checked={specialForm.exService === 'Y'}
                onChange={handleChange} /><span>Yes</span>
            </label>
            <label className="radio-container">
              <input type="radio" name="exService" value="N"
                checked={specialForm.exService === 'N'}
                onChange={handleChange} /><span>No</span>
            </label>
          </div>
        </div>
        <div className='special-container'>
          <div className='special-item'>
            <h5>Srilankan Tamil Refugee:<br />
              <span>&ensp;இலங்கைத் தமிழ் அகதிகள்</span>
            </h5>
          </div>
          <div className='special-item'>
            <label className="radio-container">
              <input type="radio" name="srilankanRefugee" value="Y"
                checked={specialForm.srilankanRefugee === 'Y'}
                onChange={handleChange} /><span>Yes</span>
            </label>
            <label className="radio-container">
              <input type="radio" name="srilankanRefugee" value="N"
                checked={specialForm.srilankanRefugee === 'N'}
                onChange={handleChange} /><span>No</span>
            </label>
          </div>
        </div>
        <h4 className='section-title'>Scholarship Details</h4>
        <div className='special-container'>
          <div className='special-item'>
            <h5>First Graduate:<br />
              <span>&ensp;முதல் பட்டதாரி</span>
            </h5>
          </div>
          <div className='special-item'>
            <label className="radio-container">
              <input type="radio" name="firstGraduate" value="Y"
                checked={specialForm.firstGraduate === 'Y'}
                onChange={handleChange} /><span>Yes</span>
            </label>
            <label className="radio-container">
              <input type="radio" name="firstGraduate" value="N"
                checked={specialForm.firstGraduate === 'N'}
                onChange={handleChange} /><span>No</span>
            </label>
          </div>
        </div>
      </div>
      <br />
      <div className='next-button'>
        <button className='log-btn button button-secondary' onClick={handlePrev}>Previous</button>
        <button className='log-btn button button-primary' onClick={handleSpecialDetailSubmit}>Save & Next</button>
      </div>
      <div style={{ position: 'relative', alignSelf: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <PopModal
          isOpen={isModalOpen}
          type={modalType}
          confirmButtonText="OK"
          showCancelButton={showCancelButton}
          cancelButtonText="Cancel"
          onConfirm={onConfirm}
          onCancel={onCancel}
        />
      </div>
    </section>
  )
}

export default Special;